import React, { FunctionComponent, SelectHTMLAttributes } from 'react';
import { InputWrapper, getFieldA11yProps } from '../InputWrapper';
import classNames from 'classnames';
import { ChevronDownIcon } from '../SvgIcons';

// Import Local Styles
import styles from './select.module.css';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
  hint?: boolean;
  wrapperClass?: string;
  valid?: boolean;
  label: string;
  selected?: boolean;
  qaTag?: string;
  modifier?: string;
  defaultValue?: string;
  showHint?: boolean;
}

export const Select: FunctionComponent<SelectProps> = (props) => {
  const { name, error, showHint, children, disabled = false, selected, valid, onChange, onBlur, defaultValue } = props;

  const onChangeFn = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    ev.preventDefault();
    if (onChange) onChange(ev);
  };

  const onBlurFn = (ev: React.FocusEvent<HTMLSelectElement>) => {
    ev.preventDefault();
    if (onBlur) onBlur(ev);
  };

  const innerWrapperClassList = classNames({
    [styles.wrapper]: true,
    [styles.selected]: selected,
    [styles.error]: error,
    [styles.valid]: valid,
    [styles.disabled]: disabled,
  });

  return (
    <InputWrapper {...props} id={name}>
      <div className={innerWrapperClassList}>
        <select
          className={styles.select}
          disabled={disabled}
          id={name}
          aria-required={props['aria-required']}
          {...getFieldA11yProps({ id: name, error, showHint })}
          name={name}
          onBlur={(ev) => onBlurFn(ev)}
          onChange={(ev) => onChangeFn(ev)}
          defaultValue={defaultValue}
        >
          {children}
        </select>
        <ChevronDownIcon />
      </div>
    </InputWrapper>
  );
};
